import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import {
  DeleteSharp,
  EditSharp,
  RemoveRedEye,
  Add,
  ArrowLeft,
  Schedule
} from "@mui/icons-material";
import {
  Card,
  Stack,
  Container,
  Typography,
  Button,
  Tooltip,
  Box,
  IconButton,
  Badge,
  Chip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  Modal
} from "@mui/material";
import Page from "../components/Page";
import { deletePoll, getpollresult, batchInsertPoll, getPollChildren, getPollByBatch, updatePoll } from "src/api/commonapi";
import { PollSelect, fetchPollList } from "src/utils/common";
import { notification } from "src/utils/messages";
import Deletemodal from "./DeleteModal";
import { CSVLink } from "react-csv";
import moment from "moment";
import CustomLoader from "src/commonComponents/CustomLoader";
import DeleteConfirmDialog from "./Notification/DeleteConfirmDialog";
import PollForm from "./Poll/PollForm";
import PollFilters from "./Poll/PollFilters";
import PollScheduleModal from "./Poll/PollScheduleModal";

export default function Poll() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));

  // Page state: 0=list, 1=add, 2=edit
  const [pollPage, setPollPage] = useState(0);

  const getDefaultFormData = () => ({
    p_type: loginUser?.u_type == 0 ? 0 : 2,
    p_type_id: 0,
    question: "",
    show_on_home: 0,
    schedule_entries: [
      {
        s_date: moment().format("DD-MM-YYYY"),
        e_date: "",
        notification_send_type: "0",
        n_date_time: "",
        show_on_home: 0,
        _uid: `entry_${Date.now()}`
      }
    ]
  });

  const [getdata, setgetdata] = useState(getDefaultFormData());
  const [myModal, setMyModal] = useState(false);
  const [answer, setanswer] = useState([]);
  const [response, setresponse] = useState(0);
  const [polldata, setpolldata] = useState([]);
  const [pollResult, setPollResult] = useState({});
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [openId, setOpenId] = useState(null);
  const [editingPoll, setEditingPoll] = useState(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deletingRow, setDeletingRow] = useState(null);
  const [subCount, setSubCount] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [scheduleParentRow, setScheduleParentRow] = useState(null);
  const [scheduleReadOnly, setScheduleReadOnly] = useState(false);
  const [removeSubIds, setRemoveSubIds] = useState([]);

  // Server-side filter state
  const [pollFilters, setPollFilters] = useState({
    p_type: 0,
    poll_status: 0,
    poll_send_status: -1,
    search: ""
  });

  // Pagination state
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    totalRecords: 0,
    totalPages: 0
  });

  // id -> name maps for Location column (backend returns null names for multi-select)
  const [locationNames, setLocationNames] = useState({ 1: {}, 2: {}, 3: {} });

  const getPollList = async (filters = {}, page = 1, limit = 10) => {
    setIsLoading(true);
    const result = await fetchPollList(loginUser.city_id, loginUser.u_type, {
      ...filters,
      page,
      limit
    });
    setpolldata(result.data || []);
    const p = result.pagination || {};
    setPagination({
      currentPage: p.current_page || p.currentPage || 1,
      perPage: p.per_page || p.perPage || 10,
      totalRecords: p.total_records || p.totalRecords || 0,
      totalPages: p.total_pages || p.totalPages || 0
    });
    setIsLoading(false);
  };

  useEffect(() => {
    getPollList({
      p_type: pollFilters.p_type,
      poll_status: pollFilters.poll_status,
      poll_send_status: pollFilters.poll_send_status,
      search: pollFilters.search
    }, pagination.currentPage, pagination.perPage);
  }, [response, pollFilters]);

  useEffect(() => {
    const loadLocationNames = async () => {
      const maps = { 1: {}, 2: {}, 3: {} };
      for (const t of [1, 2, 3]) {
        try {
          const resp = await PollSelect(String(t), loginUser?.u_type, loginUser?.city_id);
          const list = Array.isArray(resp) ? resp : resp?.data || [];
          list.forEach((e) => {
            maps[t][String(e.value)] = e.name;
          });
        } catch (e) {
          console.error("Error loading location names:", e);
        }
      }
      setLocationNames(maps);
    };
    loadLocationNames();
  }, []);

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
    getPollList({
      p_type: pollFilters.p_type,
      poll_status: pollFilters.poll_status,
      poll_send_status: pollFilters.poll_send_status,
      search: pollFilters.search
    }, newPage, pagination.perPage);
  };

  const handlePerRowsChange = async (newPerPage, newPage) => {
    setPagination((prev) => ({ ...prev, perPage: newPerPage, currentPage: newPage }));
    getPollList({
      p_type: pollFilters.p_type,
      poll_status: pollFilters.poll_status,
      poll_send_status: pollFilters.poll_send_status,
      search: pollFilters.search
    }, newPage, newPerPage);
  };

  const deletepoll = async (p_id) => {
    const resp = await deletePoll(p_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };

  const getPollResult = async (p_id) => {
    const resp = await getpollresult(p_id);
    if (resp.status != 0) {
      setPollResult(resp);
    }
  };

  const cancelModal = () => {
    setMyModal(false);
  };

  const resetFormData = () => {
    setgetdata(getDefaultFormData());
    setanswer([]);
    setEditingPoll(null);
    setShowValidation(false);
    setPollPage(0);
    setScheduleReadOnly(false);
    setRemoveSubIds([]);
  };

  const handleSubmit = async () => {
    setShowValidation(true);
    const entries = getdata.schedule_entries || [];
    if (entries.length === 0) {
      notification({ type: "error", message: "At least one schedule entry is required." })();
      return;
    }

    const immediateCount = entries.filter(
      (e) => e.notification_send_type === "1"
    ).length;
    if (immediateCount > 1) {
      notification({ type: "error", message: "Only one entry can be 'Send Immediately' per batch." })();
      return;
    }

    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      if (!entry.s_date || !entry.e_date) {
        notification({ type: "error", message: `Entry ${i + 1}: Start and End dates are required.` })();
        return;
      }
      if (moment(entry.e_date, "DD-MM-YYYY").isBefore(moment(entry.s_date, "DD-MM-YYYY"))) {
        notification({ type: "error", message: `Entry ${i + 1}: End date cannot be before start date.` })();
        return;
      }
      if (entry.notification_send_type === "0" && !entry.n_date_time) {
        notification({ type: "error", message: `Entry ${i + 1}: Send Date & Time is required for scheduled entries.` })();
        return;
      }
    }

    if (
      (getdata.p_type != 0 && (getdata.p_type_id == 0 || getdata.p_type_id == undefined)) ||
      getdata.question == "" ||
      getdata.question == undefined
    ) {
      notification({ type: "error", message: "Please Fill Required Fields" })();
      return;
    }

    if (answer.length == 0 || answer.some((e) => e.value == "")) {
      notification({ type: "error", message: "Please Enter Answers" })();
      return;
    }

    setIsLoading(true);
    let fdata = new FormData();
    fdata.append("p_type", getdata.p_type);
    fdata.append("p_type_id", getdata.p_type == 0 ? 0 : getdata.p_type_id);
    fdata.append("p_question", getdata.question);
    fdata.append("show_on_home", getdata.show_on_home);
    answer.forEach((a) => fdata.append("p_answer", a.value));

    const schedulePayload = entries
      .filter((e) => {
        if (!editingPoll) return true;
        const sent =
          String(e.notification_send_status) === "1" || String(e.poll_send_status) === "1";
        return !sent;
      })
      .map((e) => {
        const obj = {
          s_date: e.s_date,
          e_date: e.e_date,
          notification_send_type: String(e.notification_send_type),
          n_date_time: e.n_date_time || "",
          show_on_home: e.show_on_home || 0
        };
        if (editingPoll && e.p_id) obj.p_id = e.p_id;
        return obj;
      });
    fdata.append("schedule_entries", JSON.stringify(schedulePayload));

    if (editingPoll) {
      fdata.append("p_id", editingPoll.p_id);
      fdata.append("linked_edit", "1");
      if (removeSubIds.length > 0) {
        fdata.append("remove_sub_ids", JSON.stringify(removeSubIds));
      }
    }

    try {
      const resp = editingPoll
        ? await updatePoll(fdata)
        : await batchInsertPoll(fdata);
      setIsLoading(false);
      notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      })();
      resetFormData();
      setresponse(response + 1);
    } catch (e) {
      setIsLoading(false);
      notification({ type: "error", message: "Something went wrong" })();
    }
  };

  const handleEditPoll = async (row) => {
    await loadPollForEdit(row);
    setPollPage(2);
  };

  const loadPollForEdit = async (row) => {
    let data = { ...row };
    let pollAnswerSource = row;
    const isSubPoll = row.parent_p_id && row.parent_p_id !== "" && row.parent_p_id !== null;
    setScheduleReadOnly(isSubPoll);
    setRemoveSubIds([]);

    try {
      if (isSubPoll) {
        data.schedule_entries = [{
          s_date: row.s_date,
          e_date: row.e_date,
          notification_send_type: String(row.poll_send_type ?? row.notification_send_type ?? "0"),
          n_date_time: row.n_date_time || row.p_date_time || "",
          show_on_home: row.show_on_home || 0,
          p_id: row.p_id,
          is_main: row.is_main || 0,
          notification_send_status: row.poll_send_status,
          _uid: `entry_${row.p_id}`
        }];
      } else {
        // Fetch full batch so every entry keeps its p_id (ID-based update).
        let batchRows = null;
        try {
          const batchResp = await getPollByBatch(row.p_id);
          if (batchResp.status === 1 && batchResp.data && batchResp.data.length > 0) {
            batchRows = [...batchResp.data].sort(
              (a, b) => (Number(b.is_main) === 1 ? 1 : 0) - (Number(a.is_main) === 1 ? 1 : 0)
            );
            const mainApiEntry =
              batchRows.find((r) => Number(r.is_main) === 1) || batchRows[0];
            pollAnswerSource = mainApiEntry;
          }
        } catch (be) {
          console.error("Error fetching poll batch:", be);
        }
        if (batchRows) {
          data.schedule_entries = batchRows.map((r) => ({
            s_date: r.s_date,
            e_date: r.e_date,
            notification_send_type: String(r.poll_send_type ?? r.notification_send_type ?? "0"),
            n_date_time: r.n_date_time || r.p_date_time || "",
            show_on_home: r.show_on_home || 0,
            p_id: r.p_id,
            is_main: Number(r.is_main) === 1 ? 1 : 0,
            notification_send_status: r.poll_send_status,
            poll_send_status: r.poll_send_status,
            _uid: `entry_${r.p_id}`
          }));
        } else {
          const resp = await getPollChildren(row.p_id);
          if (resp.status === 1 && resp.data && resp.data.length > 0) {
            const mainApiEntry = resp.data.find(
              (r) => r.is_main === 1 || r.is_main === "1"
            ) || resp.data[0];
            pollAnswerSource = mainApiEntry;
          }
          const mainSchedule = {
            s_date: row.s_date,
            e_date: row.e_date,
            notification_send_type: String(row.poll_send_type ?? row.notification_send_type ?? "0"),
            n_date_time: row.n_date_time || row.p_date_time || "",
            show_on_home: row.show_on_home || 0,
            p_id: row.p_id,
            is_main: 1,
            notification_send_status: row.poll_send_status,
            _uid: `entry_${row.p_id}`
          };
          const subEntries =
            resp.status === 1 && resp.data
              ? resp.data.map((r) => ({
                  s_date: r.s_date,
                  e_date: r.e_date,
                  notification_send_type: String(r.poll_send_type ?? r.notification_send_type ?? "0"),
                  n_date_time: r.n_date_time || r.p_date_time || "",
                  show_on_home: r.show_on_home || 0,
                  p_id: r.p_id,
                  is_main: 0,
                  notification_send_status: r.poll_send_status,
                  _uid: `entry_${r.p_id}`
                }))
              : [];
          data.schedule_entries = [mainSchedule, ...subEntries];
        }
      }
    } catch (e) {
      console.error("Error fetching poll children:", e);
    }

    let answerFromPoll = [];
    const answerSource = pollAnswerSource.p_answer || data.p_answer;
    if (answerSource) {
      let rawAnswers = answerSource;
      if (typeof rawAnswers === "string") {
        if (rawAnswers.includes("|||")) {
          rawAnswers = rawAnswers.split("|||");
        } else {
          try {
            const parsed = JSON.parse(rawAnswers);
            rawAnswers = Array.isArray(parsed) ? parsed : [rawAnswers];
          } catch {
            rawAnswers = [rawAnswers];
          }
        }
      }
      if (Array.isArray(rawAnswers)) {
        answerFromPoll = rawAnswers.filter(Boolean).map((a) => ({ value: a }));
      }
    }

    setgetdata({
      p_type: String(data.p_type || "0"),
      p_type_id: data.p_type_id,
      question: data.p_question || data.question,
      show_on_home: data.show_on_home || 0,
      schedule_entries: data.schedule_entries || []
    });
    setanswer(answerFromPoll);
    setEditingPoll(data);
  };

  const handleScheduleEntryRemove = (pId) => {
    setRemoveSubIds((prev) => [...prev, pId]);
  };

  const handleDeleteClick = (row) => {
    const subCount = row.sub_count || 0;
    if (subCount > 0) {
      setDeletingRow(row);
      setSubCount(subCount);
      setDeleteConfirmOpen(true);
      return;
    }
    setDvisible({ mval: true, id: row.p_id });
  };

  const handleConfirmDelete = async () => {
    if (!deletingRow) return;
    const resp = await deletePoll(deletingRow.p_id);
    notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    })();
    if (resp.status == 1) {
      setresponse(response + 1);
      setDeleteConfirmOpen(false);
      setDeletingRow(null);
    }
  };

  const isEditable = (row) => {
    return row.poll_send_status !== 1 && row.poll_send_status !== "1";
  };

  const expo_columns = [
    { label: "No", key: "p_id" },
    { label: "Poll Question", key: "p_question" },
    { label: "Poll Type", key: "p_type" },
    { label: "Start Date", key: "s_date" },
    { label: "End Date", key: "e_date" }
  ];

  const handleOpenSchedule = (row) => {
    setScheduleParentRow(row);
    setScheduleModalOpen(true);
  };

  const columns = [
    {
      name: "No",
      selector: (row) => row.p_id,
      sortable: true,
      width: "70px"
    },
    {
      name: "Start Date",
      selector: (row) => row.s_date,
      sortable: true
    },
    {
      name: "End Date",
      selector: (row) => row.e_date,
      sortable: true
    },
    {
      name: "Poll Question",
      selector: (row) => row.p_question
    },
    {
      name: "Poll Type",
      selector: (row) =>
        row.p_type == 1 ? "State" : row.p_type == 2 ? "City" : row.p_type == 3 ? "Chapter" : "LVB"
    },
    {
      name: "Location",
      wrap: true,
      cell: (row) => {
        if (String(row.p_type) === "0") return "LVB";
        const direct =
          String(row.p_type) === "1"
            ? row.s_name
            : String(row.p_type) === "2"
              ? row.city_name
              : row.ch_name;
        if (direct) return direct;
        // Backend returns null names for multi-select p_type_id (e.g. "[38,1]") —
        // resolve actual names client-side via preloaded option lists.
        const raw = String(row.p_type_id ?? "").replace(/^\[|]$/g, "");
        const ids = raw.split(",").map((v) => v.trim()).filter((v) => v && v !== "0");
        if (!ids.length) return "-";
        const map = locationNames[String(row.p_type)] || {};
        const names = ids.map((id) => map[String(id)] || `#${id}`);
        const content = names.join(", ");
        return (
          <div title={content}>
            {content.length > 40 ? `${content.slice(0, 40)}...` : content}
          </div>
        );
      }
    },
    {
      name: "Schedules",
      width: "100px",
      center: true,
      cell: (row) => {
        const count = row.sub_count || 0;
        if (count <= 0) return null;
        return (
          <Tooltip title={`${count} schedule ${count === 1 ? "entry" : "entries"}`}>
            <IconButton size="small" onClick={() => handleOpenSchedule(row)}>
              <Badge badgeContent={count} color="primary" max={99}>
                <Schedule fontSize="small" />
              </Badge>
            </IconButton>
          </Tooltip>
        );
      },
      ignoreRowClick: true
    },
    {
      name: "Action",
      cell: (row) => {
        const editable = isEditable(row);
        return (
          <>
            <Tooltip title={!editable ? "Cannot delete sent poll" : "Delete"}>
              <span>
                <IconButton disabled={!editable} onClick={() => handleDeleteClick(row)}>
                  <DeleteSharp color={!editable ? "disabled" : "error"} />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title={!editable ? "Cannot edit sent poll" : "Edit"}>
              <span>
                <IconButton disabled={!editable} onClick={() => handleEditPoll(row)}>
                  <EditSharp color={!editable ? "disabled" : "warning"} />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="View Result">
              <IconButton
                onClick={() => {
                  getPollResult(row.p_id);
                  setMyModal(true);
                }}
              >
                <RemoveRedEye color="success" />
              </IconButton>
            </Tooltip>
          </>
        );
      }
    }
  ];

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={deletepoll} />
      <DeleteConfirmDialog
        open={deleteConfirmOpen}
        onClose={() => {
          setDeleteConfirmOpen(false);
          setDeletingRow(null);
        }}
        onConfirm={handleConfirmDelete}
        subCount={subCount}
      />
      <PollScheduleModal
        open={scheduleModalOpen}
        onClose={() => {
          setScheduleModalOpen(false);
          setScheduleParentRow(null);
        }}
        parentRow={scheduleParentRow}
        onEdit={handleEditPoll}
        onDelete={handleDeleteClick}
        onViewResult={(pId) => {
          getPollResult(pId);
          setMyModal(true);
        }}
      />

      <Modal
        open={myModal}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 720,
            outline: "none"
          }}
        >
          <Card sx={{ borderRadius: 3, display: "flex", flexDirection: "column", maxHeight: "80vh" }}>
            <Box sx={{ p: 3, pb: 1 }}>
              <Typography variant="h6" fontWeight={600}>
                Poll Result
              </Typography>
            </Box>
            <Box sx={{ px: 3, pb: 2, overflowY: "auto", flex: 1 }}>
              <Box sx={{ p: 2, mb: 2, borderRadius: 2, bgcolor: "#e6f4f1", border: "1px solid #cce3df" }}>
                <Typography variant="caption" color="text.secondary">POLL QUESTION</Typography>
                <Typography fontWeight={500}>{pollResult.question}</Typography>
              </Box>
              <Chip label={`Total Responses: ${pollResult.total_vote}`} sx={{ mb: 2 }} />
              {pollResult.option?.map((e, index) => {
                const pre =
                  Math.round(
                    ((e.vote_counter * 100) / pollResult.total_vote + Number.EPSILON) * 100
                  ) / 100;
                const users = pollResult.userlist?.filter((us) => us.p_c_id === e.p_c_id);
                return (
                  <Box
                    key={e.p_c_id}
                    sx={{
                      mb: 2,
                      p: 2,
                      borderRadius: 2,
                      bgcolor: "#f9fafb",
                      border: "1px solid #eee",
                      cursor: "pointer",
                      "&:hover": { boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }
                    }}
                    onClick={() => setOpenId(openId === e.p_c_id ? null : e.p_c_id)}
                  >
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#888" }}>
                          {index + 1}.
                        </Typography>
                        <Typography fontSize={14}>{e.p_c_option || "N/A"}</Typography>
                      </Box>
                      <Box display="flex" gap={1} alignItems="center">
                        <Chip label={e.vote_counter || 0} size="small" color="success" />
                        <Typography fontSize={13}>{pre || 0}%</Typography>
                      </Box>
                    </Box>
                    <Box sx={{ mt: 1, height: 8, borderRadius: 5, bgcolor: "#e0e0e0" }}>
                      <Box
                        sx={{
                          height: "100%",
                          borderRadius: 5,
                          bgcolor: "#1976d2",
                          width: `${pre || 0}%`
                        }}
                      />
                    </Box>
                    <Collapse in={openId === e.p_c_id}>
                      <Box mt={2}>
                        <Box display="flex" justifyContent="end" alignItems="center" mb={1}>
                          {users?.length > 0 && (
                            <CSVLink data={users} headers={export_readPollDetailColumns} filename="Poll_Result.csv">
                              <Button size="small" variant="outlined">Export CSV</Button>
                            </CSVLink>
                          )}
                        </Box>
                        {users?.length > 0 ? (
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Person Name</TableCell>
                                <TableCell>Chapter Name</TableCell>
                                <TableCell>Answer Date</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {users.map((us, i) => (
                                <TableRow key={i}>
                                  <TableCell>{i + 1}</TableCell>
                                  <TableCell>{us.m_name || "-"}</TableCell>
                                  <TableCell>{us.chpt_name || "-"}</TableCell>
                                  <TableCell>{us.p_r_date || "-"}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        ) : (
                          <Typography variant="body2" color="text.secondary">No data found</Typography>
                        )}
                      </Box>
                    </Collapse>
                  </Box>
                );
              })}
            </Box>
            <Box sx={{ p: 2, textAlign: "right" }}>
              <Button variant="outlined" onClick={cancelModal}>Close</Button>
            </Box>
          </Card>
        </Box>
      </Modal>

      <Page title="Poll | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography variant="h4" gutterBottom className="mb-0">
              Poll
            </Typography>
            {pollPage === 0 ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setgetdata(getDefaultFormData());
                  setanswer([]);
                  setEditingPoll(null);
                  setPollPage(1);
                }}
              >
                <Add sx={{ fontSize: "20px", marginRight: "5px" }} />
                Add Poll
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="primary"
                onClick={resetFormData}
              >
                <ArrowLeft sx={{ fontSize: "20px", marginRight: "5px" }} />
                Back
              </Button>
            )}
          </Stack>

          {pollPage !== 0 ? (
            <Card style={{ padding: "25px", marginBottom: "25px" }}>
              <PollForm
                getdata={getdata}
                setgetdata={setgetdata}
                answer={answer}
                setanswer={setanswer}
                editingPoll={editingPoll}
                showValidation={showValidation}
                setShowValidation={setShowValidation}
                isLoading={isLoading}
                loginUser={loginUser}
                onSubmit={handleSubmit}
                onCancel={resetFormData}
                scheduleReadOnly={scheduleReadOnly}
                onScheduleEntryRemove={handleScheduleEntryRemove}
              />
            </Card>
          ) : (
            <>
              {/* Poll Filters */}
              <PollFilters
                pollFilters={pollFilters}
                setPollFilters={setPollFilters}
                loginUser={loginUser}
              />

              {/* Poll Table */}
              <Card>
            {polldata && (
              <>
                <Button className="btn btn-export">
                  <CSVLink
                    data={polldata}
                    headers={expo_columns}
                    filename={"PollData.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                <DataTable
                  highlightOnHover
                  columns={columns}
                  data={polldata}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                  pagination
                  paginationServer
                  paginationTotalRows={pagination?.totalRecords || 0}
                  paginationPerPage={pagination?.perPage || 10}
                  paginationDefaultPage={pagination?.currentPage || 1}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerRowsChange}
                />
              </>
            )}
          </Card>
            </>
          )}
        </Container>
      </Page>
    </>
  );
}

const export_readPollDetailColumns = [
  { label: "Person Name", key: "m_name" },
  { label: "Chapter Name", key: "chpt_name" },
  { label: "Answer Date", key: "p_r_date" }
];
